import {
  ChangeDetectionStrategy, Component, ElementRef, EventEmitter, Input, Output,
  ViewChild
} from '@angular/core'
import { FormGroup } from '@angular/forms'

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UploadFileComponent {

  supportedFilesRegExp
  extensions: string
  @Input() disableUpload = true
  @Input() parent: FormGroup
  @Input() preselectedFile: string
  @Input() placeholder = 'File'
  @Input() filesCountLimit = 1

  @Input() set supportedFileExtensions(val: string[]) {
    if (val) {
      this.extensions = val.reduce((acc, cur) => !acc ? cur : acc + '|' + cur, '')
      this.supportedFilesRegExp = new RegExp(`.(${this.extensions})$`, 'i')
    }
  }

  @Output() upload = new EventEmitter<File>()
  @Output() fileChanged = new EventEmitter<any>()
  @Output() error = new EventEmitter<string>()
  @ViewChild('fileSrc') fileSrcInput: ElementRef
  @ViewChild('file') fileInput: ElementRef
  @ViewChild('draggable') draggableElem: ElementRef

  browse() {
    this.fileInput.nativeElement.click()
  }

  onChange(e) {
    const file = e.target.files[0]
    this.fileSrcInput.nativeElement.value = file.name
    this.fileChanged.emit(e.target.files[0])
    this.disableUpload = false
  }

  uploadFile(files) {
    this.upload.emit(files[0])
    this.disableUpload = true
  }

  drop(e) {
    e.stopPropagation()
    e.preventDefault()

    if (!e.dataTransfer.files.length || e.dataTransfer.files.length > this.filesCountLimit) {
      return this.error.emit(`Supported exactly ${this.filesCountLimit} file(s)`)
    }
    if (!e.dataTransfer.files[0].type.match(this.supportedFilesRegExp)) {
      return this.error.emit(`Unsupported file, supported (${this.extensions})`)
    }

    this.fileInput.nativeElement.files = e.dataTransfer.files

  }

  dragenter(e) {
    e.stopPropagation()
    e.preventDefault()

  }

  dragover(e) {
    e.stopPropagation()
    e.preventDefault()
  }

  dragend(e) {
    const dt = e.dataTransfer
    if (dt.items) {
      for (let i = 0; i < dt.items.length; i++) {
        dt.items.remove(i)
      }
    } else {
      e.dataTransfer.clearData()
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/upload/upload-file/upload-file.component.ts